export function getContributorsFromAuthors(authors) {
  return authors.filter(author => author.type && author.type.toUpperCase() === 'CONTRIBUTOR' && author.shortBio);
}
